import React from "react";
import './AboutUs.css'
import {ClickHereImageButton} from "../ClickHereImageButton";
import onlineBibleImage from "../../images/home-image-button-online-bible.jpg";
import onlineDonationsImage from "../../images/home-image-button-online-donations.jpg";
import {SubPageHeader} from "../SubPageHeader";
import ChurchHistory from "./ChurchHistory";
import Footer from "../Footer";

function AboutUs() {
    return (
        <div>
            <SubPageHeader title='About Us'/>
            <div className='image-buttons-container'>
                <ClickHereImageButton title='Church History' linkPath='/church-history' imagePath={onlineBibleImage} component={ChurchHistory}/>
                <ClickHereImageButton title='Our Mission' linkPath='/our-mission' imagePath={onlineDonationsImage}/>
                <ClickHereImageButton title='Our Leaders' linkPath='our-leaders' imagePath={onlineBibleImage}/>
                <ClickHereImageButton title='Our Vision' linkPath='our-vision' imagePath={onlineBibleImage}/>
                <ClickHereImageButton title='Core Values' linkPath='core-values' imagePath={onlineBibleImage}/>
            </div>
            <Footer/>
            }
        </div>
    )
}

export default AboutUs;
